function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    cartDrawerTop();
  
    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
  
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
  
      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        if (summaryElement.nextElementSibling !== null) {
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }
      }, 100);
    }
  }  

  openMenuDrawer(summaryElement) {
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
        this.announcement = document.querySelector('.section_announcement_bar.cs-position-1'); 
        if(this.announcement){
          document.documentElement.style.setProperty('--announcement-height', `${this.announcement.offsetHeight}px`);

        } else {
          document.documentElement.style.setProperty('--announcement-height', `0px`);

        }
        deviceHeight();
      });
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }


  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

function deviceHeight(){
  var screenHeight = window.innerHeight || document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--screen-height', screenHeight + 'px');
  this.headerGroup = document.querySelector('.headerGroup');
  this.locationBarMb = document.querySelector('.desktop-localization-wrapper');
  document.documentElement.style.setProperty('--drawer-minus-height', `${this.locationBarMb.offsetHeight + this.headerGroup.offsetHeight}px`);
}

window.addEventListener("resize", deviceHeight);
window.addEventListener("scroll", deviceHeight);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
      var contentPaginationDots = document.querySelectorAll(".pagination-gallery-items");
      contentPaginationDots.forEach ((contentPaginationDot) => {
        const countPaginationNumber = document.querySelector(".counter-gallery-item").textContent;
        var contentpaginationNew = contentPaginationDot.querySelector("span").textContent;
        if( countPaginationNumber == contentpaginationNew ) {
          contentPaginationDot.classList.add('active');
        }
        else {
          contentPaginationDot.classList.remove('active');
        }
  })
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, {once: true});
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    // const valueColorElements = document.querySelectorAll('.value-color');
    // valueColorElements.forEach((valueColorElement) => {
    //   valueColorElement.addEventListener('click', this.onValueColorClick.bind(this));
    // });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
        const wishListEls = document.querySelectorAll(".wishlist-engine[data-variant_id]");
    if(wishListEls){
      wishListEls.forEach(el => {
        el.setAttribute("data-variant_id", this.currentVariant.id);
      });
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      const wishlistChecking = document.querySelector('.wishlist-engine-btn-checking');
      if (wishlistChecking){
        wishlistChecking.classList.add('tw-hidden');
        wishlistChecking.classList.add('tw-right-0');
        wishlistChecking.classList.add('tw-absolute');
      }
      const wishlistBtnrl = document.querySelector('.wishlist-engine-btn-rl');
      if (wishlistBtnrl){
        wishlistBtnrl.classList.remove('tw-hidden');
        wishlistChecking.classList.add('tw-right-0');
        wishlistChecking.classList.add('tw-absolute');
      }
      
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const notifyButton = productForm.querySelector('.btn-notify-me');
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');

      if (text) {
        addButtonText.textContent = text;
        if (notifyButton) {
          notifyButton.classList.remove('!tw-hidden');
          notifyButton.classList.add('!tw-flex');
          addButton.classList.add('!tw-hidden');
        } 
      }
      
    } else {
      addButtonText.textContent = window.variantStrings.addToCart;
      const addButtonTextss = addButtonText.textContent
      addButton.removeAttribute('disabled');
      addButton.classList.remove('!tw-hidden');
    }

    if (!modifyClass) return;
    if (!disable) {
      addButtonText.textContent = window.variantStrings.addToCart;
      const addButtonTextss = addButtonText.textContent
      if (addButtonTextss){
        addButton.removeAttribute('disabled');
        if (notifyButton) {
          addButton.classList.remove('!tw-hidden');
          notifyButton.classList.add('!tw-hidden');
          notifyButton.classList.remove('!tw-flex');
        } 
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// CUNSTOM FUNCTION 
// *******************
// *******************

function cartDrawerTop(){
  this.headerGroup = document.querySelector('.headerGroup');
  document.documentElement.style.setProperty('--headerGroupheight', `${this.headerGroup.offsetHeight}px`);
}
window.addEventListener("resize", cartDrawerTop);

function refreshPage() {
  window.location.reload();
}


function layoutChange(layoutType) {
  const gridLayout = document.querySelector('.layout-grid');
  const listLayout = document.querySelector('.layout-list');
  const productGridContainer = document.getElementById('ProductGridContainer');

  if (layoutType === 'list') {
    gridLayout.style.display = 'block';
    listLayout.style.display = 'none';
    productGridContainer.classList.remove('list-layout');
    productGridContainer.classList.add('grid-layout');
  } else if (layoutType === 'grid') {
    gridLayout.style.display = 'none';
    listLayout.style.display = 'block';
    productGridContainer.classList.add('list-layout');
    productGridContainer.classList.remove('grid-layout');
  }
}




function CheckAccountProfile() {
  setTimeout(function() {
    const currentHash = window.location.hash;
    const accountSidebar = document.querySelector('.section-account-sidebar');
    const orderHistoryEl = document.getElementById("order-history");
    const accountSection = document.getElementById("profile-account");
    const breadcrumbPrderHistoryEl = document.getElementById("breadcrumb-order-history");
    const breadcrumbAccountSection = document.getElementById("breadcrumb-account-profile");
    if (currentHash.includes('account-profile')) {
      const accountSidebar = document.querySelector('.section-account-sidebar');
      if (accountSidebar && accountSection) {
        accountSidebar.classList.add('active-profile-section');
        breadcrumbAccountSection.style.display = "contents";
        breadcrumbPrderHistoryEl.style.display = "none";
        accountSection.style.display = "block";
        orderHistoryEl.style.display = "none";
      }else {
        accountSidebar.classList.remove('active-profile-section');
        breadcrumbAccountSection.style.display = "none";
        breadcrumbPrderHistoryEl.style.display = "contents";
        accountSection.style.display = "none";
        orderHistoryEl.style.display = "block";
      }
    }else if(currentHash.includes('order-history')){
      if (accountSidebar && orderHistoryEl) {
        accountSidebar.classList.add('active-profile-section');
        breadcrumbAccountSection.style.display = "none";
        breadcrumbPrderHistoryEl.style.display = "contents";
        orderHistoryEl.style.display = "block";
        accountSection.style.display = "none";
      }else {
        accountSidebar.classList.remove('active-profile-section');
        breadcrumbAccountSection.style.display = "contents";
        breadcrumbPrderHistoryEl.style.display = "none";
        orderHistoryEl.style.display = "none";
        accountSection.style.display = "block";
      }
    }
  }, 1000);
}


// Caution
function processElements() {
  const contentDivs = document.querySelectorAll('[role="radiogroup"] input ~ label div.needsclick.kl-private-reset-css-Xuajs1');

  if (contentDivs.length > 0) {
    clearInterval(intervalID);
  }

  contentDivs.forEach(div => {
    const words = div.textContent.trim().split(' '); 
    if (words.length >= 2) {
      words[words.length - 2] = '<span style="text-decoration:underline;" onclick="btnPrivacyLink()" >' + '&nbsp;' + words[words.length - 2] + ' ' + words[words.length - 1] + '</span>';
      words.pop(); 
    }
    div.innerHTML = '';
  
    const wrappedContent = words.join(' ');
    div.innerHTML = wrappedContent;
    window.textRadioKlavio = div.innerHTML;

    let observer = new MutationObserver(mutationRecords => {
      if(mutationRecords[0].target.innerHTML != window.textRadioKlavio) mutationRecords[0].target.innerHTML = window.textRadioKlavio;
    });

    observer.observe(div, {
      childList: true, // observe direct children
      subtree: true, // and lower descendants too
      characterDataOldValue: true // pass old data to callback
    });

    const parent = div.parentNode;
    const customLabel = document.createElement('p');
    customLabel.className = 'custom-inputlabel';
    customLabel.innerHTML = wrappedContent;
    //parent.insertBefore(customLabel, div);


    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('inputlabel-cs');

    wrapperDiv.appendChild(customLabel);
    //parent.insertBefore(wrapperDiv, div);
  });
}
let intervalID;
window.addEventListener("load", () => {
  // intervalID = setInterval(processElements, 500);
});


function editAddressBtn(targetId) {
  const targetDiv = document.getElementById(targetId);
  const allAddressDivs = document.querySelectorAll('.address-info-warpper');
  allAddressDivs.forEach(div => {
      div.style.display = 'none';
  });
  
  if (targetDiv) {
      if (targetDiv.style.display === 'none') {
          targetDiv.style.display = 'block';
          targetDiv.style.opacity = '0';
      } else {
          targetDiv.style.display = 'none';
      }
  }

  const allAddressContainers = document.querySelectorAll('.address-info-container');
  allAddressContainers.forEach(container => {
      const containerId = container.getAttribute('address-id');
      if (containerId === targetId) {
          const titleAddress = document.querySelector(".title-address");
          container.style.display = 'block';
          container.querySelector('.address-info-warpper').classList.add("edit-address");
          document.querySelector('.btn-add-new-cs').style.display = 'none';
          titleAddress.innerHTML = CustomerAddressesEdit;
      } else {
          container.style.display = 'none';
      }
  });

  var checkCountryTime;
  function checkCountry() {
    const parentSize = targetDiv.closest(".address-div");
    clearInterval(checkCountryTime);
    const checkProvince = parentSize.querySelector(".select-province label");
    const checkCountry  = parentSize.querySelector(".select-addresscountry select.address-edit-country");
    const checkLabelcountry = parentSize.querySelector("label.edit-label-country");
    const valueSelectCountry = checkCountry.options[checkCountry.selectedIndex].text;
    if(valueSelectCountry.includes("---") && !checkLabelcountry.classList.contains('select-empty')) {
      checkLabelcountry.classList.add("select-empty");
    } else if (!valueSelectCountry.includes("---")) {
      checkLabelcountry.classList.remove("select-empty");
    }
    if (targetDiv) {
      if (targetDiv.style.display === 'block') {
          targetDiv.style.opacity = '1';
      }
  }
  }
  checkCountryTime = setInterval(checkCountry, 10);
}

function newAddresses() {
  const allAddressContainer = document.querySelectorAll('.address-info-container');
  allAddressContainer.forEach(container => {
    const titleAddress = document.querySelector(".title-address");
      container.querySelector('.address-info-warpper').classList.add("edit-address");
      container.style.display = 'none';
      document.querySelector('.btn-add-new-cs').style.display = 'none';
      document.querySelector('#AddAddress').style.display = 'block';
      titleAddress.innerHTML = CustomerAddressesNew;
  });
}

function resetAddresses() {
  const allAddressDivsWrapper = document.querySelectorAll('.address-info-warpper');
  allAddressDivsWrapper.forEach(div => {
      const titleAddress = document.querySelector(".title-address");
      div.style.display = '';
      div.classList.remove("edit-address");
      document.querySelector('.btn-add-new-cs').style.display = '';
      titleAddress.innerHTML = CustomerAddressesTitle;
  });

  const allAddressDivs = document.querySelectorAll('.address-div');
  allAddressDivs.forEach(div => {
      div.style.display = 'none';
  });

  const allAddressContainers = document.querySelectorAll('.address-info-container');
  allAddressContainers.forEach(container => {
      container.style.display = '';
  });
  
    const checkMessageErrs = document.querySelectorAll('.field');
    checkMessageErrs.forEach(checkMessageErr => {
      const checkInputErr = checkMessageErr.querySelector('input');
      if (checkInputErr.classList.contains('invalid-field')) {
        const invalidFeedbackInner = checkMessageErr.querySelector('.invalid-feedback')
        invalidFeedbackInner.textContent = '';
        checkInputErr.classList.remove('invalid-field');
      }
    })
  document.querySelector('#AddAddress').style.display = 'none';
  document.querySelector('.btn-add-new-cs').style.display = '';
}

// Swatcher Function
function changeSwatcher(clickedElement) {
  const parentSwatcher = clickedElement.closest(".product-card-wrapper");
  const valueColorElements = parentSwatcher.querySelectorAll(".box-swatcher");

  const variantSection = parentSwatcher.querySelector(".card-option-size-inner");
  const variantElements = variantSection.querySelectorAll(".variant-loop");
  variantElements.forEach(variantElement => {
    variantSection.removeChild(variantElement);
    const cardOptionSizeContain = variantSection.closest('.card-option-size');
    cardOptionSizeContain.classList.remove('active');
  });
  const PlusBtn = parentSwatcher.querySelector('.plus-cs');
  const MinusBtn = parentSwatcher.querySelector('.minus-cs');
  PlusBtn.style.display = 'block';
  MinusBtn.style.display = 'none';  

  valueColorElements.forEach(valueColorElement => {
    valueColorElement.classList.remove("active");
  });

  clickedElement.classList.add("active");

  
  const jsonDataElement = clickedElement.querySelector(".json-data");
  if (jsonDataElement) {
    const jsonData = JSON.parse(jsonDataElement.textContent);
    const tagContentElement = clickedElement.querySelector(".json-meta-data-tag"); 
    const tagContentCommingElement = clickedElement.querySelector(".json-meta-data-tag-comingsoon");
    const tagContentRegurlarElement = clickedElement.querySelector(".json-meta-data-tag-regular");
    const handle = jsonData.handle;
    const images = jsonData.images || [];
    const srcsetWidths = [165, 360, 533, 720, 940, 1066];
    const sizes = "(min-width: 1600px) 975px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)";
    const mediaElements = parentSwatcher.querySelectorAll(".img-product img.motion-reduce");
    const maxImages = Math.min(mediaElements.length, images.length);
    updateCardElements(parentSwatcher, jsonData);
    updateTagsProductCard(tagContentElement, tagContentRegurlarElement, tagContentCommingElement, parentSwatcher);
    parentSwatcher.setAttribute('data-variant-number', jsonData.variants.length);

    
    for (let index = 0; index < maxImages; index++) {
      const mediaElement = mediaElements[index];
      const imageBaseName = images[index];
      const srcset = srcsetWidths.map((width) => {
        return `${imageBaseName}&amp;width=${width} ${width}w`;
      }).join(", ");

      mediaElement.src = `${imageBaseName}&amp;width=${srcsetWidths[srcsetWidths.length - 1]}`;
      mediaElement.srcset = srcset;
      mediaElement.sizes = sizes;
    }
    
    const cardProductTitle = parentSwatcher.querySelector(".cardproduct-title");
    if (cardProductTitle) {
      cardProductTitle.href = `/product/${handle}`;
    }
    const cardProductWrapper = parentSwatcher.querySelector(".card-wrapper.product-card-wrapper");
    if (cardProductWrapper) {
      cardProductWrapper.setAttribute('data-handle', `${handle}`);
    }
    
  }
  
  const parentCardOptionSize = parentSwatcher.querySelector(".card-option-size");
  if (parentCardOptionSize) {
    const innerCardOptionSize = parentCardOptionSize.querySelector(".data-size");

    innerCardOptionSize.textContent = "";
  
    const parentJsonVariantData = clickedElement.querySelector(".json-variant-data");
    if (parentJsonVariantData) {
      const newDataSizeElement = parentJsonVariantData.querySelector(".data-size");
      if (newDataSizeElement) {
        const newDataSize = newDataSizeElement.textContent;
        innerCardOptionSize.textContent = newDataSize;
      }
    }
  }

  // Checking if All variant soldout
  let allVariantsSoldout = jsonData.variants.every(variant => !variant.available);

  const soldoutTags = parentSwatcher.querySelector('.cardproduct-soldout-tags');
  
  if (allVariantsSoldout) {
    if (soldoutTags) {
      soldoutTags.textContent = SoldOutTag;
    }
  } else {
    if (soldoutTags) {
      soldoutTags.textContent = "";
    }
  }
}

function updateTagsProductCard(tagContentElement, tagContentRegurlarElement, tagContentCommingElement, parentSwatcher){
  if (tagContentElement) {
    const tagContent = tagContentElement.textContent;
    const cardProductTag = parentSwatcher.querySelector(".cardproduct-tags");
    if (cardProductTag) {
        cardProductTag.innerHTML = tagContent;
    } 
  } else {
    const cardProductTag = parentSwatcher.querySelector(".cardproduct-tags");
    if (cardProductTag) {
        cardProductTag.innerHTML = '';
    }
  }

  if (tagContentRegurlarElement) {
    const tagContent = tagContentRegurlarElement.textContent;
    const cardProductTag = parentSwatcher.querySelector(".cardproduct-tags-regurlar");
    if (cardProductTag) {
        cardProductTag.innerHTML = tagContent;
    } 
  } else {
    const cardProductTag = parentSwatcher.querySelector(".cardproduct-tags-regurlar");
    if (cardProductTag) {
        cardProductTag.innerHTML = '';
    }
  }

  if (tagContentCommingElement) {
    const tagContent = tagContentCommingElement.textContent;
    const cardProductTag = parentSwatcher.querySelector(".cardproduct-tags-comingsoon");
    if (cardProductTag) {
        cardProductTag.innerHTML = tagContent;
    } 
  } else {
    const cardProductTag = parentSwatcher.querySelector(".cardproduct-tags-comingsoon");
    if (cardProductTag) {
        cardProductTag.innerHTML = '';
    }
  }
}

function formatPrice(price) {
    const numericPrice = (price / 100);
    const formattedPrice = `${currencyCode}${numericPrice}`;
    return formattedPrice;
}

function updateCardElements(parentSwatcher, jsonData) {
  const regularPriceElement = parentSwatcher.querySelector(".price__regular .price-item--regular");
  if (regularPriceElement && jsonData.price) {
    const formattedPrice = formatPrice(jsonData.price);
    regularPriceElement.textContent = formattedPrice;
  }

  const salePriceRegularElement = parentSwatcher.querySelector(".price__sale .price-item--sale");
  const salePriceSaleElement = parentSwatcher.querySelector(".price__sale .price-item--regular");
  const customPriceElement = parentSwatcher.querySelector(".custom-price");
  const discountPercentageElement = parentSwatcher.querySelector(".discount-percentage");

  if (salePriceRegularElement && jsonData.price) {
    const formattedPrice = formatPrice(jsonData.price);
    salePriceRegularElement.textContent = formattedPrice;

    const salePrice = parseFloat(jsonData.price) / 100;
    const regularPrice = parseFloat(jsonData.compare_at_price) / 100;
    if (regularPrice > salePrice) {
      customPriceElement.classList.add("price--on-sale");
    } else {
      customPriceElement.classList.remove("price--on-sale");
    }
    const discountPercentage = ((regularPrice - salePrice) / regularPrice) * 100;
    discountPercentageElement.textContent = `${discountPercentage.toFixed(0)}% off`;
  }

  if (salePriceSaleElement && jsonData.compare_at_price) {
    const formattedPrice = formatPrice(jsonData.compare_at_price);
    salePriceSaleElement.textContent = formattedPrice;
  }
}

function createVariantElements(data) {

  const dataSizeElement = data.querySelector('.data-size');
  const productTags = data.querySelector('.itemAccesorios');

  const jsonData = JSON.parse(dataSizeElement.textContent);
  const btnProductPage = document.querySelector(".product-btn-buy_mb")
  const parentSize = data.closest(".product-card-wrapper");
  const handleValue = parentSize.getAttribute('data-handle');
  const cardOptionSizeInner = parentSize.querySelector('.card-option-size-inner');
  const cardOptionSizeContain = parentSize.querySelector('.card-option-size');
  let dataHref = (data.getAttribute("data-href")) ? data.getAttribute("data-href") : "";
  const linkToPage = parentSize.querySelector('.linkto-page') ;
  if (productTags){
    const variantElement = document.createElement('div');
    variantElement.classList.add('variant-loop');
    variantElement.setAttribute('data-variant-id', jsonData[0].id);
    if(jsonData[0].price > 0){
      if (jsonData[0].available === false) {
        variantElement.innerHTML = `
          <product-form class="product-form !tw-mt-0">
            <form method="post" action="/cart/add" id="product-form-template--${jsonData[0].id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="id" value="${jsonData[0].id}" class="product-variant-id">
              <div class="product-form__buttons !tw-max-w-full !tw-relative">
                <button id="ProductSubmitButton-${jsonData[0].id}" type="submit" name="add" class="product-form__submit button !tw-font-Avenregular">
                ${AddToCart}
                <svg  class="tw-ml-[4px] envelop-svg" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                <path d="M12.375 0H0.375C0.275544 0 0.180161 0.0395088 0.109835 0.109835C0.0395088 0.180161 0 0.275544 0 0.375V8.875C0 9.10706 0.0921873 9.32962 0.256282 9.49372C0.420376 9.65781 0.642936 9.75 0.875 9.75H11.875C12.1071 9.75 12.3296 9.65781 12.4937 9.49372C12.6578 9.32962 12.75 9.10706 12.75 8.875V0.375C12.75 0.275544 12.7105 0.180161 12.6402 0.109835C12.5698 0.0395088 12.4745 0 12.375 0ZM11.4113 0.75L6.5 4L1.33875 0.75H11.4113ZM11.875 9H0.875C0.841848 9 0.810054 8.98683 0.786612 8.96339C0.76317 8.93995 0.75 8.90815 0.75 8.875V1.2275L6.25 4.785C6.31913 4.84824 6.40943 4.88332 6.50313 4.88332C6.59682 4.88332 6.68712 4.84824 6.75625 4.785L12 1.2275V8.875C12 8.90815 11.9868 8.93995 11.9634 8.96339C11.9399 8.98683 11.9082 9 11.875 9Z" fill="#979797"/>
                </svg>
                </button>
              </div>
            </form>
          </product-form>
        `;
      } else {
        variantElement.innerHTML = `
        <product-form class="product-form !tw-mt-0 !tw-relative">
          <form method="post" action="/cart/add" id="product-form-template--${jsonData[0].id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="id" value="${jsonData[0].id}" class="product-variant-id">
            <div class="product-form__buttons !tw-max-w-full">
              <button id="ProductSubmitButton-${jsonData[0].id}"  type="submit" name="add" class="product-form__submit button !tw-font-Avenregular">${AddToCart}</button>
            </div>
          </form>
        </product-form>
      `;
      }
    }
    cardOptionSizeInner.appendChild(variantElement);
    cardOptionSizeInner.querySelector('.variant-loop').classList.add('button-full');
  } else if (linkToPage){
    jsonData.forEach(variant => {
      if(variant.price > 0){
        const variantElement = document.createElement('div');
        variantElement.classList.add('variant-loop');
        variantElement.setAttribute('data-variant-id', variant.id);
         let hiddenIfNoPrice = (variant.price > 0) ? "" : "!tw-hidden" ;
          if (variant.available === false) {
            variantElement.innerHTML = `
              <product-form class="product-form !tw-mt-0 !tw-relative ${hiddenIfNoPrice}">
                <form method="post" action="/cart/add" id="product-form-template--${variant.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="id" value="${variant.id}" class="product-variant-id">
                  <div class="product-form__buttons !tw-max-w-full">
                    <button type="button" id="ProductSubmitButton-${variant.id}" class="product-form__submit button !tw-font-Avenregular" onclick="triggerBtn(this, '#klaviyo-bis-trigger-${variant.id}')">
                      <span>${variant.options}</span>
                      <svg  class="tw-ml-[4px] envelop-svg" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                      <path d="M12.375 0H0.375C0.275544 0 0.180161 0.0395088 0.109835 0.109835C0.0395088 0.180161 0 0.275544 0 0.375V8.875C0 9.10706 0.0921873 9.32962 0.256282 9.49372C0.420376 9.65781 0.642936 9.75 0.875 9.75H11.875C12.1071 9.75 12.3296 9.65781 12.4937 9.49372C12.6578 9.32962 12.75 9.10706 12.75 8.875V0.375C12.75 0.275544 12.7105 0.180161 12.6402 0.109835C12.5698 0.0395088 12.4745 0 12.375 0ZM11.4113 0.75L6.5 4L1.33875 0.75H11.4113ZM11.875 9H0.875C0.841848 9 0.810054 8.98683 0.786612 8.96339C0.76317 8.93995 0.75 8.90815 0.75 8.875V1.2275L6.25 4.785C6.31913 4.84824 6.40943 4.88332 6.50313 4.88332C6.59682 4.88332 6.68712 4.84824 6.75625 4.785L12 1.2275V8.875C12 8.90815 11.9868 8.93995 11.9634 8.96339C11.9399 8.98683 11.9082 9 11.875 9Z" fill="#979797"/>
                      </svg>                
                    </button>
                    <a class="btn klaviyo-bis-trigger" id="klaviyo-bis-trigger-${variant.id}" href="#" style="padding: inherit; text-align: center; display: none" data-klaviyo-handle="${handleValue}">SEND</a>
                  </div>
                </form>
                <div class="overlay-notify-btn !tw-absolute !tw-w-full !tw-h-full !tw-block" onclick="triggerBtn(this, '.btn.klaviyo-bis-trigger')"></div>
              </product-form>
            `;
          } else {
            let variantHref = "#";
            if(dataHref){
              variantHref = dataHref + "?variant=" + variant.id;
            }
            variantElement.innerHTML = `
              <product-form class="product-form !tw-mt-0 ${hiddenIfNoPrice}">
                <form method="post" action="/cart/add" id="product-form-template--${variant.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="id" value="${variant.id}" class="product-variant-id">
                  <div class="product-form__buttons !tw-max-w-full !tw-relative">
                    <a style="text-decoration: none;" href="${variantHref}" id="ProductSubmitButton-${variant.id}" name="add" class="product-form__submit button !tw-font-Avenregular">${variant.options}</a>
                  </div>
                </form>
              </product-form>
            `;
        }
        cardOptionSizeInner.appendChild(variantElement);
      }
    });
  } else {
    if (jsonData.length <= 1) {
      const variantElement = document.createElement('div');
      variantElement.classList.add('variant-loop');
      variantElement.setAttribute('data-variant-id', jsonData[0].id);
      if(jsonData.price > 0){
        if (jsonData.available === false) {
  
          variantElement.innerHTML = `
            <product-form class="product-form !tw-mt-0">
              <form method="post" action="/cart/add" id="product-form-template--${jsonData[0].id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                <input type="hidden" name="form_type" value="product">
                <input type="hidden" name="id" value="${jsonData[0].id}" class="product-variant-id">
                <div class="product-form__buttons !tw-max-w-full !tw-relative">
                  <button id="ProductSubmitButton-${jsonData[0].id}" type="submit" name="add" class="product-form__submit button !tw-font-Avenregular">
                  ${AddToCart}
                  <svg  class="tw-ml-[4px] envelop-svg" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                  <path d="M12.375 0H0.375C0.275544 0 0.180161 0.0395088 0.109835 0.109835C0.0395088 0.180161 0 0.275544 0 0.375V8.875C0 9.10706 0.0921873 9.32962 0.256282 9.49372C0.420376 9.65781 0.642936 9.75 0.875 9.75H11.875C12.1071 9.75 12.3296 9.65781 12.4937 9.49372C12.6578 9.32962 12.75 9.10706 12.75 8.875V0.375C12.75 0.275544 12.7105 0.180161 12.6402 0.109835C12.5698 0.0395088 12.4745 0 12.375 0ZM11.4113 0.75L6.5 4L1.33875 0.75H11.4113ZM11.875 9H0.875C0.841848 9 0.810054 8.98683 0.786612 8.96339C0.76317 8.93995 0.75 8.90815 0.75 8.875V1.2275L6.25 4.785C6.31913 4.84824 6.40943 4.88332 6.50313 4.88332C6.59682 4.88332 6.68712 4.84824 6.75625 4.785L12 1.2275V8.875C12 8.90815 11.9868 8.93995 11.9634 8.96339C11.9399 8.98683 11.9082 9 11.875 9Z" fill="#979797"/>
                  </svg>
                  </button>
                </div>
              </form>
            </product-form>
          `;
        } else {
          variantElement.innerHTML = `
          <product-form class="product-form !tw-mt-0 !tw-relative">
            <form method="post" action="/cart/add" id="product-form-template--${jsonData[0].id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="id" value="${jsonData[0].id}" class="product-variant-id">
              <div class="product-form__buttons !tw-max-w-full">
                <button id="ProductSubmitButton-${jsonData[0].id}"  type="submit" name="add" class="product-form__submit button !tw-font-Avenregular">${AddToCart}</button>
              </div>
            </form>
          </product-form>
        `;
        }
      }
      cardOptionSizeInner.appendChild(variantElement);
      cardOptionSizeInner.querySelector('.variant-loop').classList.add('button-full');
  
    } else {
      jsonData.forEach(variant => {
        if(variant.price > 0){
  
          const variantElement = document.createElement('div');
          variantElement.classList.add('variant-loop');
          variantElement.setAttribute('data-variant-id', variant.id);
           let hiddenIfNoPrice = (variant.price > 0) ? "" : "!tw-hidden" ;
            if (variant.available === false) {
              variantElement.innerHTML = `
                <product-form class="product-form !tw-mt-0 !tw-relative ${hiddenIfNoPrice}">
                  <form method="post" action="/cart/add" id="product-form-template--${variant.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="id" value="${variant.id}" class="product-variant-id">
                    <div class="product-form__buttons !tw-max-w-full">
                      <button id="ProductSubmitButton-${variant.id}" class="product-form__submit button !tw-font-Avenregular" onclick="triggerBtn(this, '#klaviyo-bis-trigger-${variant.id}')">
                        <span>${variant.options}</span>
                        <svg  class="tw-ml-[4px] envelop-svg" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                        <path d="M12.375 0H0.375C0.275544 0 0.180161 0.0395088 0.109835 0.109835C0.0395088 0.180161 0 0.275544 0 0.375V8.875C0 9.10706 0.0921873 9.32962 0.256282 9.49372C0.420376 9.65781 0.642936 9.75 0.875 9.75H11.875C12.1071 9.75 12.3296 9.65781 12.4937 9.49372C12.6578 9.32962 12.75 9.10706 12.75 8.875V0.375C12.75 0.275544 12.7105 0.180161 12.6402 0.109835C12.5698 0.0395088 12.4745 0 12.375 0ZM11.4113 0.75L6.5 4L1.33875 0.75H11.4113ZM11.875 9H0.875C0.841848 9 0.810054 8.98683 0.786612 8.96339C0.76317 8.93995 0.75 8.90815 0.75 8.875V1.2275L6.25 4.785C6.31913 4.84824 6.40943 4.88332 6.50313 4.88332C6.59682 4.88332 6.68712 4.84824 6.75625 4.785L12 1.2275V8.875C12 8.90815 11.9868 8.93995 11.9634 8.96339C11.9399 8.98683 11.9082 9 11.875 9Z" fill="#979797"/>
                        </svg>                
                      </button>
                      <a class="btn klaviyo-bis-trigger" id="klaviyo-bis-trigger-${variant.id}" href="#" style="padding: inherit; text-align: center; display: none" data-klaviyo-handle="${handleValue}">SEND</a>
                    </div>
                  </form>
                  <div class="overlay-notify-btn !tw-absolute !tw-w-full !tw-h-full !tw-block" onclick="triggerBtn(this, '.btn.klaviyo-bis-trigger')"></div>
                </product-form>
              `;
            } else if (btnProductPage){
              variantElement.innerHTML = `
                <product-form class="product-form !tw-mt-0 ${hiddenIfNoPrice}">
                  <form method="post" action="/cart/add" id="product-form-template--${variant.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="id" value="${variant.id}" class="product-variant-id">
                    <div class="product-form__buttons !tw-max-w-full !tw-relative">
                    <button id="ProductSubmitButton-${variant.id}" type="submit" name="add" class="product-form__submit button !tw-font-Avenregular">${variant.options}</button>
                    </div>
                  </form>
                </product-form>
              `;
            }
          cardOptionSizeInner.appendChild(variantElement);
        }
      });
    }
  }
  cardOptionSizeContain.classList.add('active');
}


function removeVariantElements(variantElements, parentElement) {
  variantElements.forEach(variantElement => {
    parentElement.removeChild(variantElement);
    const cardOptionSizeContain = parentElement.closest('.card-option-size');
    cardOptionSizeContain.classList.remove('active');
  });
}

// On desktop
// function handleMouseEnter(cardInner) {
//   if (window.innerWidth > 990) {
//     createVariantElements(cardInner);
//   }
// }

// function handleMouseLeave(cardInner) {
//   if (window.innerWidth > 990) {
//     removeVariantElements(cardInner.querySelectorAll('.variant-loop'), cardInner.querySelector('.card-option-size-inner'));
//   }
// }

// On Mobile

function handlePlusClick(cardInnercs) {
    createVariantElements(cardInnercs);
    const PlusBtn = cardInnercs.querySelector('.plus-cs');
    const MinusBtn = cardInnercs.querySelector('.minus-cs');
    PlusBtn.style.display = 'none';
    MinusBtn.style.display = 'block';
    getOperatingSystem();
}

function handleMinusClick(cardInnercs) {
    removeVariantElements(cardInnercs.querySelectorAll('.variant-loop'), cardInnercs.querySelector('.card-option-size-inner'));
    const PlusBtn = cardInnercs.querySelector('.plus-cs');
    const MinusBtn = cardInnercs.querySelector('.minus-cs');
    PlusBtn.style.display = 'block';
    MinusBtn.style.display = 'none';  
}

// On product page 
function toggleVariantElements(btn) {
  const cardInner = btn.closest('.product-btn-buy_mb');
  const isActive = cardInner.getAttribute('data-active') === 'true';
    if(cardInner){
      if (!isActive) {
        createVariantElements(cardInner);
        cardInner.setAttribute('data-active', 'true');
      } else {
        removeVariantElements(cardInner.querySelectorAll('.variant-loop'), cardInner.querySelector('.card-option-size-inner'));
        cardInner.setAttribute('data-active', 'false');
      }
    }
}


// Funtion Sort product 
const sortOptionCheckboxes = document.querySelectorAll('.sort-option[type="checkbox"]');

function handleCheckboxChange(checkbox) {
  if (checkbox.checked) {
    uncheckOtherCheckboxes(checkbox);
    addSortClassToMobileFacetsInner(checkbox.value);
    filterSort();
  } else {
    removeSortClassFromMobileFacetsInner(checkbox.value);
    removeSortByFromURL();
  }
}

sortOptionCheckboxes.forEach(checkbox => {
  checkbox.addEventListener('change', () => {
    handleCheckboxChange(checkbox);
  });
});

function uncheckOtherCheckboxes(checkedCheckbox) {
  sortOptionCheckboxes.forEach(checkbox => {
    if (checkbox !== checkedCheckbox) {
      checkbox.checked = false;
    }
  });
}

function removeSortByFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete('sort_by');
  const newUrl = window.location.pathname + '?' + urlParams.toString();
  window.history.replaceState({}, '', newUrl);
}

function checkInitialCheckbox() {
  const checkedCheckbox = Array.from(sortOptionCheckboxes).find(checkbox => checkbox.checked);
  if (!checkedCheckbox) {
    removeSortByFromURL();
  }
}
const mobileFacetsInner = document.querySelector('.mobile-facets__inner');

function addSortClassToMobileFacetsInner(sortValue) {
  const existingClasses = mobileFacetsInner.className.split(' ');
  const filteredClasses = existingClasses.filter(className => !className.startsWith('sort-option-'));
  filteredClasses.push(`sort-option-${sortValue}`);
  mobileFacetsInner.className = filteredClasses.join(' ');
}

function removeSortClassFromMobileFacetsInner(sortValue) {
  mobileFacetsInner.classList.remove(`sort-option-${sortValue}`);
}

function filterSort(){
  const sortOptionRadios = document.querySelectorAll('.sort-option[type="checkbox"]');
  const checkedSortOption = Array.from(sortOptionRadios).find(checkbox => checkbox.checked);
  if (!checkedSortOption) {
    return;
  }
  checkSort();
}
function checkSort() {
  setTimeout(function() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortValues = urlParams.getAll('sort_by');
    if (sortValues.length > 0) {
      const lastSortValue = sortValues[sortValues.length - 1];
      const radioButton = document.getElementById(lastSortValue);
      if (radioButton) {
        radioButton.checked = true;
      }
    }
  }, 1500);
}



class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.button = document.getElementById('size-guide-button');
    this.modal = document.getElementById('size-guide-modal');
    this.overlay = document.querySelector('.size-guide-modal-overlay');
    this.closeButton = document.querySelector('.modal__header__close');
    this.section = this.closest('section.page-width');
    this.button.addEventListener('click',this.onOpenSizeGuideModal.bind(this))
    this.overlay.addEventListener('click',this.onCloseSizeGuideModal.bind(this))
    this.closeButton.addEventListener('click',this.onCloseSizeGuideModal.bind(this))
  }
  onOpenSizeGuideModal(){
    this.modal.style.display = 'flex';
    this.modal.classList.add('show-sizeguide');
    document.querySelector('body').classList.add('overflow-hidden');
    deviceHeight();
  }
  onCloseSizeGuideModal(){
    this.modal.style.display = 'none';
    this.modal.classList.remove('show-sizeguide');
    document.querySelector('body').classList.remove('overflow-hidden');
  }
}
customElements.define('size-guide', SizeGuide);

function triggerBtn(target, className) {
  let elementToClick = document.querySelector(`${className}`);
  if (elementToClick) {
      elementToClick.click();
      // document.querySelector('body').classList.add('overflow-hidden');
      
  }
}

function accodionsToggle(element) {
  var answer = element.nextElementSibling;
  element.classList.toggle('open-state');
  if (!answer.classList.contains('active')) {
    answer.style.maxHeight = answer.scrollHeight + 'px';
} else {
    answer.style.maxHeight = null;
}
  answer.classList.toggle('active');
}
function getOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/windows phone/i.test(userAgent)) {
    document.querySelector('body').classList.add('operating_windows_phone');
  }
  if (/android/i.test(userAgent)) {
    document.querySelector('body').classList.add('operating_android');
  }
  if (/(MAC|Mac|iPhone|iPod|iPad)/.test(userAgent) && !window.MSStream) {
    document.querySelector('body').classList.add('operating_ios');
  }
  if (/win/i.test(userAgent) || /windows/i.test(userAgent)) {
    document.querySelector('body').classList.add('operating_windows');
  }
}
// BSS fix
if (typeof BSS_B2B && window.location.pathname.includes("/products")) {
  const buttonAddToCart = $('.product__info-wrapper .product-form button[name="add"]:not(button.button.button-add-to-cart)')
  if (buttonAddToCart.length) {
    buttonAddToCart.on("click", function () {
      setTimeout(() => {
          let headerDiscountForm = document.querySelectorAll(".bss-b2b-translation-dc-form_header_text");
          let btnApply = document.querySelectorAll("#bss-b2b-discount-code-submit span");
          if (headerDiscountForm.length && btnApply.length) {
              headerDiscountForm.forEach((item) => {
                  item.innerText = BSS_B2B.dcTranslations ? BSS_B2B.dcTranslations.form_header_text : "";
              });
              btnApply.forEach((item) => {
                  item.innerText = BSS_B2B.dcTranslations ? BSS_B2B.dcTranslations.button_apply : "";
              });
          }
      }, 1200)
    });
  }
}
// BSS end fix
let startX;
let scrollLeft;
function cusorGrabingMousedown(slider, e){
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
}

function cusorGrabingMouseleave(slider, e){
  isDown = false;
  slider.classList.remove('active');
}

function cusorGrabingMouseup(slider, e){
  isDown = false;
  slider.classList.remove('active');
}

function cusorGrabingMousemove(slider, e){
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
}